import TripsListAdminContainer from './TripsListAdminContainer';
export default TripsListAdminContainer;
